import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const repoAppBuilder = DataRouterApplicationBuilder.create('repo')
